var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.row)?_c('m-user-layout-row',{attrs:{"user":_vm.user,"sentry-tag":"user-card.row"},on:{"onCardClick":_vm.onCardClick,"onFavoriteClick":_vm.onFavoriteClick}}):_c('m-user-layout-column',{attrs:{"user":_vm.user,"sentry-tag":"user-card.column"},on:{"onCardClick":_vm.onCardClick,"onFavoriteClick":_vm.onFavoriteClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }